module.exports = __webpack_public_path__ + "static/img/登陆背景2.b35d75e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/登陆背景2.png
// module id = fAo6
// module chunks = 0